module.exports = __webpack_public_path__ + "media/images/soar/site/bg_bottom_create-688b462ebcfc8a86c30214f75fc1ef18.svg";